import { ChangeEvent } from "react"
import { useTranslation } from "react-i18next"

import TextField from "@/components/form/textField/TextField"
import Icon from "@/components/icon/Icon"

import "./noticeSearch.scss"

export default function NoticeSearch({
  searchValue,
  setSearchValue,
}: {
  searchValue: string
  setSearchValue: (value: string) => void
}) {
  const { t } = useTranslation()

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value)
  }

  return (
    <div className="NoticeSearchCont">
      <TextField
        label=""
        placeholder={t("search")}
        value={searchValue}
        onChange={handleChange}
        appendIcon={<Icon type="search" width={24} height={24} />}
      />
    </div>
  )
}
